export const Card = {
  Platinum: 'the-platinum-card',
  Centurion: 'the-centurion-card',
  CenturionIDCEN: 'the-centurion-card-idc-en',
  Delta: 'delta-reserve',
};

export const WEEK_NAME_SUNDAY = 'sunday';
export const autoOpenedStatusSessionKey = 'aocp';
export const inlineCardCalloutPlaceholder = '{inlineCardCallout}';
export const termsModalSessionKey = 'termsModalShown';
export const pageSessionKey = 'lfPage';
export const redirectedSessionKey = 'lfRedirected';
export const loginPageValue = 'login';

export const CenturionProviders = {
  UnitedStates: 'PROVIDER_CENTURION_US',
  UnitedStatesSidecar: 'PROVIDER_CENTURION_SIDECAR_US',
};

export const LoungeTypes = {
  CENTURION: 'CENTURION',
  SIDECAR: 'SIDECAR',
  PARTNER: 'PARTNER',
};

export const termsAnchorTags = [
  'prioritypass',
  'plazapremium',
  'escapelounges',
  'centurion',
  'delta',
  'aircanada',
  'additionalpartners',
];

export const LAST_VIEWED_PRODUCT_SESSION_KEY = 'lvp';

export const featureFlagConfig = {
  UPDATED_PROGRAMS_AND_PARTNERS_ENABLED:
    'UPDATED_PROGRAMS_AND_PARTNERS_ENABLED',
  GLC_BANNER_ENABLED: 'GLC_BANNER_ENABLED',
  enabledMarkets: 'enabledMarkets',
  updatedHeaderEnabled: 'updatedHeaderEnabled',
  proxyUrl: 'proxyUrl',
  faasApiUrl: 'faasApiUrl',
  loginUrl: 'loginUrl',
  newDomainUrl: 'newDomainUrl',
  culinaryCollectiveEnabled: 'culinaryCollectiveEnabled',
  accessEnabled: 'accessEnabled',
  digitalWaitlistEnabled: 'digitalWaitlistEnabled',
  locationMapEnabled: 'locationMapEnabled',
  centurionNetworkEnabled: 'centurionNetworkEnabled',
  UPDATED_LOUNGE_SIDEBAR_ENABLED: 'UPDATED_LOUNGE_SIDEBAR_ENABLED',
};
